import * as Backend from '@/core/backend'

export async function loadTranslations () {
  const res = await Backend.callApi({
    apiName: 'Admin.LoadCustomTranslations'
  })

  return res.data
}

export async function saveTranslations (translations) {
  const res = await Backend.callApi({
    apiName: 'Admin.SaveCustomTranslations',
    inputData: {
      Translations: translations
    }
  })

  return res.data
}
